module.exports = __webpack_public_path__ + "img/lock.c05ea861.svg";